import { useEffect, useRef, useState } from "react";
import InputComponent from "../../../../shared/input/InputComponent";
import { ReferalServices } from "../../../../../services/referal.service";
import MainButton from "../../../../shared/button/MainButton";
import styles from "./CurrentAccModal.module.scss";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import close from "../../../../../assets/images/referal/Close Icon.svg";
import { toast } from "react-toastify";
import { data } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux/store";
import { fetchTranslation } from "../../../../../redux/Slices/translationDataSlice";

interface props {
  showExtraModal: boolean;
  setShowExtraModal: (value: boolean) => void;
}

const CurrentAccModal = ({ showExtraModal, setShowExtraModal }: props) => {
  const [referalId, setReferalId] = useState("");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const language = useSelector((state: RootState) => state.language.language);

  const dispatch = useDispatch<AppDispatch>();

  const { data } = useSelector((state: RootState) => state.translationData);

  const handleSubmit = async () => {
    try {
      const payload = { referalId: Number(referalId) };
      await ReferalServices.PostReferal(payload);
      toast(data?.account_added);
      setReferalId("");
    } catch (error: any) {
      setErrors(error?.content);
    }
  };
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);
  console.log(errors);

  return (
    <GlobalModalComponent
      isOpen={showExtraModal}
      onClose={() => setShowExtraModal(false)}
    >
      <div
        className={styles.close_icon}
        onClick={() => setShowExtraModal(false)}
      >
        <img src={close} alt="x" />
      </div>
      <div className={styles.current_acc_modal}>
        <h3 className={styles.title}>{data?.auth_referal_add_existing}</h3>
        <div className={styles.form}>
          <InputComponent
            type="number"
            name="referalId"
            placeholder={data?.auth_referal_account_code}
            value={referalId}
            onChange={(e) => setReferalId(e.target.value)}
            error={errors?.referalId}
          />
          <MainButton
            className={styles.buttonOrange}
            text={data?.auth_referal_add}
            onClick={handleSubmit}
            disabled={!referalId}
          />
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default CurrentAccModal;
